// Copyright (c) Move Closer 2022.

import { Component, Prop, Vue } from 'vue-property-decorator'

import { CheckoutPayload } from '../contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
@Component
export class AbstractStepPreview extends Vue {
  @Prop({ type: Object, required: true })
  public readonly payload!: CheckoutPayload
}
